module.exports = __webpack_public_path__ + "static/img/cloud-right_bottom-min.9322e64.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/website/cloud-right_bottom-min.png
// module id = 660
// module chunks = 64